import { jsx as _jsx } from "react/jsx-runtime";
import s from './ModalTextDescription.module.scss';
export default function ModalTextDescription({ text }) {
    return (_jsx("div", Object.assign({ className: s.content_left_description }, { children: _jsx("p", Object.assign({ className: s.text }, { children: text })) })));
}
